import React from "react";
import { useParams, Navigate } from "react-router-dom";
import BlogDetails from "../screens/blogs-articles/blogs-articles-details/BlogDetails";
import BlogsIntermediate from "../screens/blogs-articles/blogs-articles-intermediate/BlogsIntermediate";

// Sanitizer to normalize the topic slug and redirect if needed for blog details
export const SanitizedBlogDetails: React.FC = () => {
  const { topic = "", titleSlug = "" } = useParams<{ topic: string; titleSlug: string }>();
  const sanitizedTopic = topic
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

  if (sanitizedTopic !== topic) {
    return <Navigate to={`/blogs/${sanitizedTopic}/${titleSlug}`} replace />;
  }
  return <BlogDetails />;
};

// Sanitizer for BlogsIntermediate component
export const SanitizedBlogsIntermediate: React.FC = () => {
  const { topicSlug = "" } = useParams<{ topicSlug: string }>();
  const sanitizedTopicSlug = topicSlug
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

  if (sanitizedTopicSlug !== topicSlug) {
    return <Navigate to={`/blogs/${sanitizedTopicSlug}`} replace />;
  }
  return <BlogsIntermediate />;
};